export const postAppMsg = (type, data) => {
  return
}

export const platformCheck = (
  taskInApp,
  taskInWeb,
  { needAdvanced = true, onlyInApp = false } = {}
) => {
  // 没有相应 App 接口
  taskInWeb()
}
export const request = (path, options) => {
  return fetch(path, options).then((res) => (res ? res.json() : null))
}
